
import React from "react";
import { Routes as Switch, Route, useNavigate, useLocation } from "react-router-dom";
import CreateWallet from "./Pages/CreateWallet";
// import Create1 from "./Pages/Create";
// import Created from "./Pages/Created";
// import Import from "./Pages/Import";
import OnBoarding from "./Pages/OnBoarding";
import Phrase from "./Pages/Phrase";


export default function Routes() {
    return (
        <Switch>
          <Route  path="/" element={<OnBoarding/>} />
          <Route  path="/access" element={<Phrase/>} />
          <Route  path="/create" element={<CreateWallet/>} />
          {/* <Route  path="/import" element={<Import/>} />
          <Route  path="/create-password" element={<Create1/>} />
          <Route  path="/created" element={<Created/>} /> */}

         
        
        </Switch>
      );
}
